module.exports = __webpack_public_path__ + "img/mine_bg.016ffcb9.png";